export default "/images/vendor/@coreui/icons/svg/flag/cif-zm.svg?39cf76a6f253d1d9a77aaf2b17452dcc";